import { put } from 'redux-saga/effects';
import makeRequest from 'rdx/utils/makeRequest';
import putErrorActions from 'rdx/utils/putErrorActions';
import {
  setSpectralDataLoading,
  setSpectralDataSuccess,
  setNormalizedSpectralData,
  setSpectralDataDoneLoading,
} from 'rdx/modules/reagents/slice';

function* requestSpectralData({ payload }) {
  const { action, params } = payload;
  const { cytometerProfileID } = params;
  yield put(setSpectralDataLoading(cytometerProfileID));
  const { success, error, data } = yield* makeRequest.action(action, params);
  if (error) {
    yield* putErrorActions({ error });
    yield put(setSpectralDataDoneLoading())
    return null;
  }
  if (success && data) {
    const normalizedSpectralMatrix = data?.data?.attributes?.normalizedSpectralMatrixMeasured;
    const spectralData = { ...data };
    delete spectralData.data.attributes.normalizedSpectralMatrix;
    yield put(setSpectralDataSuccess({ data: spectralData, cytometerProfileID }));
    yield put(setNormalizedSpectralData(normalizedSpectralMatrix));
  }
  return null;
}

export default requestSpectralData;
